const account = {
  ACCOUNT_DISPLAY_SCREEN: "ACCOUNT_DISPLAY_SCREEN",
  ACCOUNT_PASSWORD_MISMATCH: "ACCOUNT_PASSWORD_MISMATCH",
  ACCOUNT_API_STARTED: "ACCOUNT_API_STARTED",
  ACCOUNT_EMAIL_UPDATE_SUCCESS: "ACCOUNT_EMAIL_UPDATE_SUCCESS",
  ACCOUNT_EMAIL_UPDATE_FAIL: "ACCOUNT_EMAIL_UPDATE_FAIL",
  ACCOUNT_CHANGE_PASSWORD_SUCCESS: "ACCOUNT_CHANGE_PASSWORD_SUCCESS",
  ACCOUNT_CHANGE_PASSWORD_FAIL: "ACCOUNT_CHANGE_PASSWORD_FAIL",
  LOGIN_INFORMATION_MAIN_VIEW: "LOGIN_INFORMATION_MAIN_VIEW",
  LOGIN_INFORMATION_EMAIL_VIEW: "LOGIN_INFORMATION_EMAIL_VIEW",
  LOGIN_INFORMATION_PASSWORD_VIEW: "LOGIN_INFORMATION_PASSWORD_VIEW",
  ACCOUNT_PERSONAL_INFORMATION_UPDATE_FAIL:
    "ACCOUNT_PERSONAL_INFORMATION_UPDATE_FAIL",
  ACCOUNT_PERSONAL_INFORMATION_UPDATE_SUCCESS:
    "ACCOUNT_PERSONAL_INFORMATION_UPDATE_SUCCESS",
  ACCOUNT_FETCH_PERSONAL_INFORMATION_SUCCESS:
    "ACCOUNT_FETCH_PERSONAL_INFORMATION_SUCCESS",
  ACCOUNT_FETCH_PERSONAL_INFORMATION_FAIL:
    "ACCOUNT_FETCH_PERSONAL_INFORMATION_FAIL",
  ACCOUNT_RESET_PASSWORD_SUCCESS: "ACCOUNT_RESET_PASSWORD_SUCCESS",
  ACCOUNT_RESET_PASSWORD_FAIL: "ACCOUNT_RESET_PASSWORD_FAIL",
  ACCOUNT_POLICY_ERROR_DISPLAY: "ACCOUNT_POLICY_ERROR_DISPLAY",
  ACCOUNT_POLICY_ERROR_HIDE: "ACCOUNT_POLICY_ERROR_HIDE",
  TOGGLE_PASSWORD_ERROR_MSG: "TOGGLE_PASSWORD_ERROR_MSG",
}

export default account
